import { DEFAULT_LANGUAGE_CODE, LanguageCode } from '@/constants/languages';
import { changeLanguage } from 'i18next';
import { create } from 'zustand';

type LanguageState = {
  locale: LanguageCode;
  setLocale: (l: LanguageCode) => void;
};

export const useLanguageStore = create<LanguageState>(set => ({
  locale: DEFAULT_LANGUAGE_CODE,

  setLocale: (l: LanguageCode) =>
    set(() => {
      changeLanguage(l);
      return { locale: l };
    }),
}));
